namespace Matrix.Workflow {
    export class ApprovalQueueColumns {
        static columnsKey = 'Workflow.ApprovalQueue';
    }
}
